/* TALAS CHROME behaviour: header scroll state, mega menu (hover intent + keyboard), cart badge,
   mobile drawer outside-click, footer accordions. Delegated listeners: the desktop header is
   inserted by common.js after first paint, so nothing here depends on init order. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;

  /* ---- scroll state (class only; CSS animates transform/opacity) ---- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('tc-scrolled', (window.pageYOffset || 0) > 40);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- mega menus (one panel per top-level item that has children) ---- */
  var openT = 0, closeT = 0, current = null;
  function panels() { return doc.querySelectorAll('.tc-mega'); }
  function setOpen(idx) {
    current = idx;
    var ps = panels();
    for (var i = 0; i < ps.length; i++) ps[i].classList.toggle('is-open', ps[i].getAttribute('data-tc-panel') === String(idx));
    var ts = doc.querySelectorAll('[data-tc-mega-toggle]');
    for (var k = 0; k < ts.length; k++) {
      var on = ts[k].getAttribute('data-tc-mega-toggle') === String(idx);
      ts[k].setAttribute('aria-expanded', on ? 'true' : 'false');
      var li = ts[k].closest('.tc-item'); if (li) li.classList.toggle('is-open', on);
    }
  }
  function idxOf(el) {
    var li = el && el.closest && el.closest('.tc-item--mega');
    if (li) { var t = li.querySelector('[data-tc-mega-toggle]'); return t && t.getAttribute('data-tc-mega-toggle'); }
    var p = el && el.closest && el.closest('.tc-mega');
    return p ? p.getAttribute('data-tc-panel') : null;
  }
  function closeSoon() { clearTimeout(closeT); closeT = setTimeout(function () { closeT = 0; setOpen(null); }, 240); }

  doc.addEventListener('mouseover', function (e) {
    if (!panels().length) return;
    var idx = idxOf(e.target);
    if (idx !== null && idx !== undefined) {
      clearTimeout(closeT); closeT = 0;
      if (String(current) !== idx) {
        clearTimeout(openT);
        openT = setTimeout(function () { openT = 0; setOpen(idx); }, current === null ? 110 : 40);
      }
    } else {
      clearTimeout(openT); openT = 0;
      if (current !== null && !closeT) closeSoon();
    }
  });
  doc.addEventListener('mouseleave', function () { clearTimeout(openT); openT = 0; if (current !== null) closeSoon(); });
  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tc-mega-toggle]');
    if (t) {
      e.preventDefault(); clearTimeout(openT); clearTimeout(closeT); openT = closeT = 0;
      var id = t.getAttribute('data-tc-mega-toggle'); setOpen(String(current) === id ? null : id); return;
    }
    if (current !== null && idxOf(e.target) === null) setOpen(null);
    var d = doc.querySelector('.header-mobile__item.is-open');
    if (d && !d.contains(e.target) && !(e.target.closest && e.target.closest('.js-main-drawer-open-button, .js-sub-drawer-open-button'))) {
      var c = d.querySelector('.js-btn-close'); if (c) c.click();
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current !== null) {
      var idx = current, inside = doc.activeElement && idxOf(doc.activeElement) !== null;
      setOpen(null);
      if (inside) { var t = doc.querySelector('[data-tc-mega-toggle="' + idx + '"]'); if (t) t.focus(); }
      return;
    }
    if (e.key === 'ArrowDown' && doc.activeElement && doc.activeElement.closest && doc.activeElement.closest('.tc-item--mega')) {
      var i2 = idxOf(doc.activeElement);
      e.preventDefault(); setOpen(i2);
      var first = doc.querySelector('.tc-mega[data-tc-panel="' + i2 + '"] a'); if (first) setTimeout(function () { first.focus(); }, 30);
    }
  });
  doc.addEventListener('focusin', function (e) {
    if (current !== null && idxOf(e.target) !== String(current)) setOpen(null);
  });

  /* ---- cart badge: hide at 0 (theme JS rewrites .js-cart-items-count text) ---- */
  var syncQueued = false;
  function syncBadges() {
    syncQueued = false;
    var bs = doc.querySelectorAll('[data-tc-badge]');
    for (var i = 0; i < bs.length; i++) {
      var n = parseInt(bs[i].textContent, 10) || 0;
      bs[i].setAttribute('data-empty', n === 0 ? 'true' : 'false');
    }
  }
  function queueSync() { if (!syncQueued) { syncQueued = true; requestAnimationFrame(syncBadges); } }
  if (window.MutationObserver) {
    new MutationObserver(queueSync).observe(doc.body || root, { childList: true, subtree: true, characterData: true });
  }
  syncBadges();

  /* ---- mobile: lift the respond.io launcher above the floating tab bar (widget sets inline !important) ---- */
  function liftChat() {
    var mq = window.matchMedia && window.matchMedia('(max-width: 991.98px)').matches;
    var f = doc.querySelector('iframe[title="Webchat Widget"],iframe[data-tchat-rio]');
    if (!f) return;
    /* our own launcher (assets/talas-chat.js) opens respond.io; its window is only shown while html.tchat-rio-on */
    var rioOn = root.classList.contains('tchat-rio-on');
    /* QA fix: on phones the PDP sticky buy bar (66px) sits just above the tab bar, so lift the launcher above it too */
    var sticky = root.classList.contains('pdp-sticky-on') && window.matchMedia('(max-width: 767.98px)').matches;
    if (mq && rioOn) {
      /* phones: respond.io's chat window is full width; keep a 16px inset from the right and bottom edges */
      f.style.setProperty('right', '16px', 'important');
      f.style.setProperty('bottom', '16px', 'important');
      f.style.setProperty('max-width', 'calc(100% - 32px)', 'important');
      f.style.setProperty('max-height', 'calc(100% - 32px)', 'important');
    } else if (mq) f.style.setProperty('bottom', 'calc(var(--tc-tabbar-offset) + 8px' + (sticky ? ' + 66px + 8px' : '') + ')', 'important');
    else f.style.setProperty('bottom', '25px', 'important');
    /* QA fix: chat window open (wide iframe) -> flag it so back-to-top can step aside on phones */
    if (f.offsetWidth > 140 && rioOn) root.setAttribute('data-tc-chat-open', ''); else root.removeAttribute('data-tc-chat-open');
    if (!f.__tcRO && window.ResizeObserver) { f.__tcRO = new ResizeObserver(liftChat); f.__tcRO.observe(f); }
  }
  if (window.MutationObserver) new MutationObserver(liftChat).observe(root, { attributes: true, attributeFilter: ['class'] });
  var liftN = 0, liftI = setInterval(function () { liftChat(); if (++liftN > 30) clearInterval(liftI); }, 700);
  window.addEventListener('resize', liftChat);
  if (window.MutationObserver) {
    var liftMO = new MutationObserver(function () { if (doc.querySelector('iframe[title="Webchat Widget"],iframe[data-tchat-rio]')) { liftChat(); liftMO.disconnect(); } });
    liftMO.observe(doc.documentElement, { childList: true, subtree: true });
  }
  /* ---- footer accordions: open + inert on desktop, closed by default on mobile (<= 767px) ---- */
  (function () {
    var mq = window.matchMedia && window.matchMedia('(max-width: 767.98px)');
    if (!mq) return;
    function accs() { return doc.querySelectorAll('[data-tc-acc]'); }
    function apply() {
      var list = accs();
      for (var i = 0; i < list.length; i++) {
        var s = list[i].querySelector('summary');
        if (mq.matches) { list[i].removeAttribute('open'); if (s) s.removeAttribute('tabindex'); }
        else { list[i].setAttribute('open', ''); }
      }
    }
    doc.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('[data-tc-acc] > summary');
      if (s && !mq.matches) e.preventDefault();
    });
    if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
    apply();
  })();
})();
